import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PolygonButton from "./polygon";
import RectangleButton from "./rectangle";

export default class TriggerButton extends Component {
    static propTypes = {
        isActive: PropTypes.bool.isRequired
    };

    render() {
        const { isActive: active, onToggle, className, common, title } = this.props;

        return common.voxButtonShape === 'default' ?
            <PolygonButton isActive={active} onToggle={onToggle} className={className} common={common} title={title} /> :
            <RectangleButton isActive={active} onToggle={onToggle} className={className} common={common} />
    }
}
